import React from "react";
import axios from "axios";
import uuid from 'react-uuid';
import S3FileUpload from 'react-s3';
import { apiCreateJob, s3Config } from '../Config';
import { isIOS, isMobile } from '../AppUtils';

class Job extends React.Component
{
    constructor(props) {
        super(props);

        this.createJob = this.createJob.bind(this);
    }

    async createJob(name, email, phone, message, mailingList, image, video, extension, onCreateJobComplete) {

        var UUID = uuid();
        var videoFileName = UUID + "." + extension;

        console.log("S3: Video upload started");
        var s3VideoConfig = {};
        Object.assign(s3VideoConfig, s3Config);
        s3VideoConfig.dirName = 'Src/Video';

        var videoFile = null;
        if (extension ==='webm') {
          videoFile = new File([video], videoFileName, {
            type: 'video/' + extension
          });
        } else {

            videoFile = new File([video], videoFileName, {type: video.type});
        }

        await S3FileUpload
          .uploadFile(videoFile, s3VideoConfig)
          .then(data => console.log(data))
          .catch(err => console.error(err));
    
        console.log("S3: image upload started");
    
        var s3ImageConfig = {};
        Object.assign(s3ImageConfig, s3Config);
        var imageFileName = UUID + '.png';

        s3ImageConfig.dirName = 'Src/Images';
        s3ImageConfig.fileName = imageFileName;
        
    
        var imageFile = new File([image], imageFileName, {
          type: "image/png"
        });
        
        await S3FileUpload
          .uploadFile(imageFile, s3ImageConfig)
          .then(data => console.log(data))
          .catch(err => console.error(err));
    
        console.log("CTE API: Submiting form");
    
        var videoMode = 0;

        if (isMobile) {
          if (isIOS) {
            videoMode = 1; // Rotate 90 deg cw
          } else {
            videoMode = 0;
          }
        } else {
          videoMode = 2; // Crop landscape
        }

        await axios.post(
          apiCreateJob,
          { 
            UUID: `${UUID}`,
            UName: `${name}`,
            Email: `${email}`,
            Phone: `${phone}`,
            Message: `${message}`,
            MailingOptIn: `${mailingList}`,
            VideoMode: `${videoMode}`
          }
        );

        onCreateJobComplete(UUID, null);
    }

    async createJob(name, email, phone, message, mailingList, images, onCreateJobComplete) {
      var UUID = uuid();
      console.log("S3: image upload started ALL IMAGES");
     
      var index = 0;

      for(var i = 0; i < images.length; i++) {

        var s3ImageConfig = {};
          Object.assign(s3ImageConfig, s3Config);
          var imageFileName = `${UUID}_${index}.png`;

          s3ImageConfig.dirName = 'Src/Images';
          s3ImageConfig.fileName = imageFileName;
          console.log("uploading");
          console.log(images[i]);

          var imageFile = new File([images[i]], imageFileName, {
            type: "image/png"
          });

          S3FileUpload
        .uploadFile(imageFile, s3ImageConfig)
        .then(data => console.log(data))
        .catch(err => console.error(err));
        
          index++;
      }
    
      console.log("CTE API: Submiting form  ALL IMAGES");

      var videoMode = 3; // ALL IMAGES

      console.log(`${UUID} : ${message}`);

      await axios.post(
        apiCreateJob,
        { 
          UUID: `${UUID}`,
          UName: `${name}`,
          Email: `${email}`,
          Phone: `${phone}`,
          Message: `${message}`,
          MailingOptIn: `${mailingList}`,
          VideoMode: `${videoMode}`
        }
      );

      onCreateJobComplete(UUID, null);
  }
}

export default Job;